function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var HongKongFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#EA1A1A",
      fillRule: "evenodd",
      d: "M0 3v18h24V3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "24",
      height: "18",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 3v18h24V3H0Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M11.902 11.681s-4.342-3.872.84-6.129c0 0 1.506 1.663.376 3.53-.37.611-.684 1.048-.919 1.377-.481.673-.637.89-.297 1.222Zm-6.408-2.78c-.299 5.643 5.107 3.49 5.107 3.49-.45.156-.574-.08-.96-.811-.19-.357-.44-.833-.822-1.438C7.655 8.296 5.494 8.9 5.494 8.9Zm8.185 2.97s5.574 1.668 1.835 5.907c0 0-2.069-.868-1.835-3.037.076-.712.174-1.24.248-1.637.151-.814.2-1.077-.248-1.234Zm-1.465 1.3s.999 5.732-4.464 4.284c0 0-.148-2.24 1.896-3 .671-.25 1.188-.399 1.576-.51.795-.229 1.052-.302.992-.774Zm6.895-2.464c-3.417-4.502-6.154.632-6.154.632.243-.409.49-.31 1.258 0 .375.15.873.351 1.556.567 2.08.657 3.34-1.2 3.34-1.2Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        stroke: "#EA1A1A",
        strokeWidth: ".5",
        d: "M7.62 10.656s1.093 1.718 2.88 1.718M11.895 8.288s-.98 1.807-.14 3.386M16.582 10.321s-2.287-.347-3.484.982M15.246 14.509s-.456-2.269-2.114-2.938M10.45 15.74s1.975-1.205 2.038-2.992"
      })]
    })]
  })]
}));
//# sourceMappingURL=HongKong.js.map